import React from 'react';
import { useSelector } from 'react-redux';

import { userSelectors } from 'reducers';
import { RoleNames } from 'utils/constants';

import KYCSurveyPM from './KYCSurveyPM';
import KYCSurveyPP from './KYCSurveyPP';

const KYCSurveyMain = props => {
    const tunnelSubscription = useSelector(userSelectors.getTunnelSubscription);

    if (tunnelSubscription?.role?.name === RoleNames.PP_PROFESSIONNEL) {
        return <KYCSurveyPP {...props} />;
    } else {
        return <KYCSurveyPM {...props} />;
    }
};

export default KYCSurveyMain;
